import { IconButton, Tooltip } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo, useRef, useState } from 'react';
import BreadCrumb from '../../../component/BreadCrumb';
import InputBox from '../../../component/InputBox';
import SelectionBox from '../../../component/SelectionBox';
import TimePickerBox from '../../../component/TimePickerBox';
import { CODE_GROUP_ID } from '../../../constant/Constant';
import CodeUtil from '../../../util/CodeUtil';
import PdfViewModal from '../../modal/PdfViewModal';
import SubjectDetailModal from '../../modal/SubjectDetailModal';
import ModalRef from '../../../component/ModalRef';
import PopupRef from '../../../component/PopupRef';
import { modalType } from '../../../util/ModalUtil';
import SubjectIcon from '../../../component/icon/SubjectIcon';
import DeleteIcon from '../../../component/icon/DeleteIcon';
import ExcelDownloadButtonBox from '../../../component/buttons/ExcelDownloadButtonBox';
import ExcelUploadButtonBox from '../../../component/buttons/ExcelUploadButtonBox';
import RegistButtonBox from '../../../component/buttons/RegistButtonBox';
import GridTimeBox from '../../../component/GridTimeBox';
import {
    actionExcelDownload,
    actionExcelUpload,
    actionSearch,
} from '../../../module/body/semester/SemesterSubjectModule';
import { actionRemove } from '../../../module/modal/SubjectDetailModule';
import SessionStorageUtil from '../../../util/SessionStorageUtil';
import { VIEW_SEMESTER_SUBJECT } from './../../../constant/ViewConstant';
import SearchButtonBox from '../../../component/buttons/SearchButtonBox';
import qs from 'qs';
import { useLocation } from 'react-router-dom';
import PathUtil from '../../../util/PathUtil';
import NullCheckUtil from '../../../util/NullCheckUtil';
import TableBox from '../../../component/TableBox';
import { defaultGridData, handleControl, initGrid } from '../../../module/component/TableBoxModule';
import AuthenticationUtil from '../../../util/AuthenticationUtil';
import SemesterUtil from '../../../util/SemesterUtil';
import { OpenEditIcon } from '../../../component/icon/GridIcons';

const ConditionArea = ({ modalRef, popupRef }) => {
    const location = useLocation();
    const queryData = qs.parse(location.search, { ignoreQueryPrefix: true });
    const dispatch = useDispatch();

    const [semesterId, setSemesterId] = useState();
    const [semesterNm, setSemesterNm] = useState();
    const lessonUniversityCd = AuthenticationUtil.getUserUniversityCd();

    const [subjectTypeCd, setSubjectTypeCd] = useState();
    const [lessonTypeCd, setLessonTypeCd] = useState();
    const [subjectNm, setSubjectNm] = useState();
    const [weekdayCd, setWeekdayCd] = useState();
    const [bgnTime, setBgnTime] = useState();
    const [endTime, setEndTime] = useState();

    const [params, setParams] = useState({});
    const { gridData } = useSelector((state) => state.tableBoxState);

    const isValidParams = (params) => {
        if (Number(params.bgnTime) > Number(params.endTime)) {
            popupRef.current.openInfo('조회조건 시작시간은 종료시간보다 작아야합니다.');
            return false;
        }

        return true;
    };

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onRowDoubleClick,
                onChangePageInfo,
                params,
            }),
        );

        // 최초 로딩시 URL 정보를 통해 설정
        var params = buildParams(queryData);
        setParams(params);
        if (isValidParams(params)) {
            dispatch(
                actionSearch({
                    params,
                    callback: (result) => {
                        if (result.totalCount == 0) {
                            popupRef.current.openAlert('조회된 결과가 없습니다.');
                        }
                    },
                }),
            );
            PathUtil.pushState(location.pathname, params);
        }

        return () => {
            dispatch(initGrid());
        };
    }, []);

    const buildParams = (queryData) => {
        var params = { lessonUniversityCd };
        if (NullCheckUtil.isNotNull(queryData.semesterId)) {
            setSemesterId(queryData.semesterId);
            setSemesterNm(SemesterUtil.convertSemesterNm(queryData.semesterId));
            params = { ...params, semesterId: queryData.semesterId };
        } else {
            setSemesterId(SessionStorageUtil.getCurrentSemesterId());
            setSemesterNm(SessionStorageUtil.getCurrentSemesterNm());
            params = { ...params, semesterId: SessionStorageUtil.getCurrentSemesterId() };
        }
        if (NullCheckUtil.isNotNull(queryData.subjectTypeCd)) {
            setSubjectTypeCd(queryData.subjectTypeCd);
            params = { ...params, subjectTypeCd: queryData.subjectTypeCd };
        }
        if (NullCheckUtil.isNotNull(queryData.subjectNm)) {
            setSemesterNm(queryData.subjectNm);
            params = { ...params, subjectNm: queryData.subjectNm };
        }
        if (NullCheckUtil.isNotNull(queryData.lessonTypeCd)) {
            setLessonTypeCd(queryData.lessonTypeCd);
            params = { ...params, lessonTypeCd: queryData.lessonTypeCd };
        }
        if (NullCheckUtil.isNotNull(queryData.weekdayCd)) {
            setWeekdayCd(queryData.weekdayCd);
            params = { ...params, weekdayCd: queryData.weekdayCd };
        }
        if (NullCheckUtil.isNotNull(queryData.bgnTime)) {
            setBgnTime(queryData.bgnTime);
            params = { ...params, bgnTime: queryData.bgnTime };
        }
        if (NullCheckUtil.isNotNull(queryData.endTime)) {
            setEndTime(queryData.endTime);
            params = { ...params, endTime: queryData.endTime };
        }
        if (NullCheckUtil.isNotNull(queryData.page)) {
            params = { ...params, page: queryData.page };
        } else {
            params = { ...params, page: defaultGridData.page };
        }
        if (NullCheckUtil.isNotNull(queryData.pageSize)) {
            params = { ...params, pageSize: queryData.pageSize };
        } else {
            params = { ...params, pageSize: 100 };
        }
        return params;
    };

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onRowDoubleClick,
                onChangePageInfo,
                params,
            }),
        );
    }, [params]);

    const onChangePageInfo = (page, pageSize) => {
        var tempParams = { ...params, page, pageSize };
        setParams(tempParams);
        if (isValidParams(tempParams)) {
            dispatch(actionSearch({ params: tempParams }));
            PathUtil.pushState(location.pathname, tempParams);
        }
    };

    const onClickSearch = (params) => {
        setParams(params);
        if (isValidParams(params)) {
            dispatch(
                actionSearch({
                    params,
                    callback: (result) => {
                        if (result.totalCount == 0) {
                            popupRef.current.openAlert('조회된 결과가 없습니다.');
                        }
                    },
                }),
            );
            PathUtil.pushState(location.pathname, params);
            // 조회된 경우 결과 화면의 학기명은 수정
            setSemesterNm(SemesterUtil.convertSemesterNm(semesterId));
        }
    };

    const onChangeSemesterId = (semesterId) => {
        setSemesterId(semesterId);
        // 조회조건이 바뀌어도 결과 화면의 학기명은 수정하지 않음
        // setSemesterNm(SemesterUtil.convertSemesterNm(semesterId));
    };

    const handleDownload = () => {
        dispatch(actionExcelDownload({ params: params }));
    };

    const handleRegist = (params) => {
        modalRef.current.open(
            <SubjectDetailModal
                type={modalType.ADD}
                callback={() => {
                    onClickSearch(params);
                }}
                modalRef={modalRef}
            />,
            'large',
        );
    };

    const handlePdfView = (row) => {
        if (NullCheckUtil.isEmpty(row.lessonPlanFileUid)) {
            popupRef.current.openAlert('강의계획서가 등록되어 있지 않습니다.');
        } else {
            modalRef.current.open(
                <PdfViewModal fileUid={row.lessonPlanFileUid} fileSize={row.lessonPlanFileSize} modalRef={modalRef} />,
                'large',
            );
        }
    };

    const handleDeleteCode = (row, params) => {
        popupRef.current.openWarning(<>{row.subjectNm}을(를) 삭제하시겠습니까?</>, () => {
            return function () {
                dispatch(
                    actionRemove({
                        data: {
                            semesterId: row.semesterId,
                            lessonUniversityCd: row.lessonUniversityCd,
                            subjectId: row.subjectId,
                            classNo: row.classNo,
                            universitySubjectId: row.universitySubjectId,
                        },
                        callback: () => {
                            popupRef.current.openInfo('삭제되었습니다.');
                            onClickSearch(params);
                        },
                    }),
                );
            };
        });
    };

    const onRowDoubleClick = (row, params) => {
        // 권한에 따라서 수정 또는 상세
        modalRef.current.open(
            <SubjectDetailModal
                type={modalType.EDIT}
                searchParams={{
                    semesterId: row.semesterId,
                    lessonUniversityCd: row.lessonUniversityCd,
                    subjectId: row.subjectId,
                    classNo: row.classNo,
                    universitySubjectId: row.universitySubjectId,
                }}
                callback={() => {
                    onClickSearch(params);
                }}
                modalRef={modalRef}
            />,
            'large',
        );
    };

    const onKeyDown = (e) => {
        if (e.key == 'Enter') {
            onClickSearch({
                lessonUniversityCd,
                semesterId,
                subjectTypeCd,
                lessonTypeCd,
                subjectNm,
                weekdayCd,
                bgnTime,
                endTime,
                page: defaultGridData.page,
                pageSize: gridData.pageSize,
            });
        }
    };

    const columns = useMemo(
        () => [
            {
                field: 'lessonUniversityCd',
                headerName: '개설대학',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
                renderCell: (params) =>
                    CodeUtil.getCodeName(CODE_GROUP_ID.MAIN_UNIVERSITY, params.row.lessonUniversityCd),
            },
            {
                field: 'subjectTypeCd',
                headerName: '과정구분',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 12,
                renderCell: (params) => CodeUtil.getCodeName(CODE_GROUP_ID.SUBJECT_TYPE, params.row.subjectTypeCd),
            },
            {
                field: 'subjectNm',
                headerName: '교과목',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 15,
            },

            { field: 'classNo', headerName: '분반', headerAlign: 'center', align: 'center', tooltip: true, flex: 4 },
            // {
            //     field: 'universitySubjectId',
            //     headerName: '교과목코드',
            //     headerAlign: 'center',
            //     align: 'center',
            //     tooltip: true,
            //     flex: 10,
            // },
            { field: 'profNm', headerName: '교강사', headerAlign: 'center', align: 'center', tooltip: true, flex: 6 },
            { field: 'creditCnt', headerName: '학점', headerAlign: 'center', align: 'center', tooltip: true, flex: 4 },
            {
                field: 'lessonTypeCd',
                headerName: '수업방식',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 12,
                renderCell: (params) => CodeUtil.getCodeName(CODE_GROUP_ID.LESSON_TYPE, params.row.lessonTypeCd),
            },
            {
                field: 'courseTimes',
                headerName: '강의시간',
                headerAlign: 'center',
                tooltip: true,
                flex: 24,
                renderCell: (params) => <GridTimeBox times={params.row.courseTimes} />,
            },
            {
                field: 'detail',
                headerName: '기능',
                headerAlign: 'center',
                align: 'center',
                flex: 16,
                disableColumnMenu: true,
                hideSortIcons: true,
                disableExport: true,
                renderCell: (item) => (
                    <>
                        <Tooltip title='수정'>
                            <IconButton onClick={() => onRowDoubleClick(item.row, params)}>
                                <OpenEditIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title='강의계획서'>
                            <IconButton onClick={(e) => handlePdfView(item.row)}>
                                <SubjectIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title='삭제'>
                            <IconButton onClick={(e) => handleDeleteCode(item.row, params)}>
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                    </>
                ),
            },
        ],
        [params],
    );

    return (
        <>
            <div className='con-form-wrap'>
                <div className='board-inner'>
                    <div className='board-row'>
                        <div className='lec-check-box'>
                            <div className='form-box-container'>
                                <SelectionBox
                                    title='학기'
                                    value={semesterId}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.SEMESTER)}
                                    onChange={(e) => onChangeSemesterId(e.target.value)}
                                    useAll={false}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <SelectionBox
                                    title='개설대학'
                                    w140
                                    value={lessonUniversityCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.MAIN_UNIVERSITY)}
                                    useAll={false}
                                    disabled
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <SelectionBox
                                    title='마이크로디그리 과정'
                                    value={subjectTypeCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.SUBJECT_TYPE)}
                                    onChange={(e) => setSubjectTypeCd(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <InputBox
                                    title='교과목'
                                    value={subjectNm}
                                    onChange={(e) => setSubjectNm(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />

                                <SelectionBox
                                    title='수업방식'
                                    w140
                                    value={lessonTypeCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.LESSON_TYPE)}
                                    onChange={(e) => setLessonTypeCd(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                            </div>
                            <div className='lec-check-btn'>
                                <SearchButtonBox
                                    title='강의조회'
                                    onClick={(e) =>
                                        onClickSearch({
                                            lessonUniversityCd,
                                            semesterId,
                                            subjectTypeCd,
                                            lessonTypeCd,
                                            subjectNm,
                                            weekdayCd,
                                            bgnTime,
                                            endTime,
                                            page: defaultGridData.page,
                                            pageSize: gridData.pageSize,
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    <div className='board-row'>
                        <div className='lec-check-box mt16'>
                            <div className='form-box-container'>
                                <SelectionBox
                                    title='요일'
                                    w140
                                    value={weekdayCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.WEEKDAY)}
                                    onChange={(e) => setWeekdayCd(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <TimePickerBox
                                    title='시작시간'
                                    value={bgnTime}
                                    onChangeTimeString={(timeString) => setBgnTime(timeString)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <TimePickerBox
                                    title='종료시간'
                                    value={endTime}
                                    onChangeTimeString={(timeString) => setEndTime(timeString)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                            </div>
                        </div>
                        {/* <CautionBox title='수강신청 유의사항 확인' /> */}
                    </div>
                </div>
            </div>
            <div className='con-tb-wrap'>
                <div className='con-tb-title  '>
                    <h3 className='tb-tit-name'>강의 목록 {semesterNm && `(${semesterNm})`}</h3>
                    <div className='btn-group'>
                        <ExcelDownloadButtonBox onClick={(e) => handleDownload()} />
                        <ExcelUploadButtonBox
                            module={actionExcelUpload}
                            params={{
                                semesterId: SessionStorageUtil.getCurrentSemesterId(),
                            }}
                            callback={() => {
                                onClickSearch({
                                    lessonUniversityCd,
                                    semesterId,
                                    subjectTypeCd,
                                    lessonTypeCd,
                                    subjectNm,
                                    weekdayCd,
                                    bgnTime,
                                    endTime,
                                    page: defaultGridData.page,
                                    pageSize: gridData.pageSize,
                                });
                            }}
                        />
                        <RegistButtonBox onClick={(e) => handleRegist(params)} />
                    </div>
                </div>
            </div>
        </>
    );
};

const SemesterSubjectView = () => {
    const modalRef = useRef(null);
    const popupRef = useRef(null);

    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='con-title-wrap conbg03'>
                    {/* <h2 className='con-title'>개설과목관리</h2> */}
                    <h2 className='con-title'>{VIEW_SEMESTER_SUBJECT.title}</h2>
                    <p className='con-title-p'>{VIEW_SEMESTER_SUBJECT.subTitle}</p>
                </div>
                <div className='sub-nav-wrap'>
                    <BreadCrumb />
                </div>
                <ConditionArea modalRef={modalRef} popupRef={popupRef} />
                <TableBox />
            </div>
            <ModalRef ref={modalRef} />
            <PopupRef ref={popupRef} />
        </section>
    );
};

export default SemesterSubjectView;
